import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import PageNotFound from "./PageNotFound";
import Cookies from "js-cookie";
import { isAuthenticated, logout } from "../../utils/AuthUtility";
import { useDispatch, useSelector } from "react-redux";
import { updateRoutingInfo } from "../../redux/routingSlice";
import { updateCommonInfo } from "../../redux/commonSlice";
import {
  EXTERNAL_GENERIC_ADMIN,
  EXTERNAL_VENDOR_GENERIC,
} from "../../constants/Constants";

const PrivateRoutes = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const roleName = useSelector(({ service }) => service.roles?.roleName);

  const checkRoute = () => {
    const verifyRoutes = [
      "new-vendor",
      "vendor-details",
      "update-profile",
      "home",
    ];

    return verifyRoutes.includes(rest.location.pathname.split("/")[1]);
  };

  //Set primary routing and vendor info
  useEffect(() => {
    let commonInfo = {};
    const pathInfo = { ...rest?.computedMatch };
    const profileId =
      pathInfo?.params?.profileId || localStorage.getItem("vid");
    const externalVendorEmail = Cookies.get("email");

    if (
      externalVendorEmail &&
      (roleName === EXTERNAL_VENDOR_GENERIC ||
        roleName === EXTERNAL_GENERIC_ADMIN)
    ) {
      commonInfo.externalVendorEmail = externalVendorEmail;
    }

    if (profileId) {
      commonInfo.profileId = profileId;
    }

    dispatch(updateCommonInfo({ ...commonInfo }));
    dispatch(updateRoutingInfo({ ...pathInfo }));
  }, [rest?.computedMatch]);

  // Update URL to reditectTo cookie when ever the route changes
  useEffect(() => {
    const pathname = rest?.location?.pathname;
    if (pathname && pathname !== "/") {
      Cookies.set("redirectTo", rest.location.pathname, { secure: true });
    }
  }, [rest.location.pathname]);

  return (
    <Route
      {...rest}
      component={(props) => {
        /**
         * Check if a user is authenticated or not
         * If a user is not authenticated, clear out cookies
         * and localStorage.
         * Logout the user.
         */
        if (rest.location.pathname !== "/" && !isAuthenticated()) {
          logout(false);
          return;
        }
        return checkRoute() ? (
          (window.location = "/mvp")
        ) : rest.path === "/*" ? (
          <PageNotFound />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default PrivateRoutes;
